import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useTabs } from "../../context/TabContext";

OpenInNewTabField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  url: PropTypes.string,
};
export default function OpenInNewTabField({ value, url }) {

  const { addNewTabAndNavigate } = useTabs();

  return (
    <Box
      onClick={() => addNewTabAndNavigate(url)}
      sx={{ cursor: 'pointer', textDecoration: 'underline' }}
    >
      {value}
    </Box>
  );
}